import * as React from "react";

export default function CloseIcon({ width = "14", height = width, className, color = "#20232B", style } = {}) {
    return (
        <svg className={className} width={width} height={height} stroke={color} style={style} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title></title>
            <g strokeWidth="2">
                <path d="M1 1L13 13"></path>
                <path d="M13 1L1 13"></path>
            </g>
        </svg>
    );
}

// <svg className={className} width={width} stroke={color} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M11 1L1 11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//     <path d="M11 11L1 1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
// </svg>
